export default "__VITE_ASSET__DYaTWA82__"